import { Overview } from 'api/Transactions/types';
import { axiosInstance } from 'api/instance';

import { AxiosResponse } from 'axios';

export const getTransactionsOverview = (): Promise<AxiosResponse<Overview>> => {
  return axiosInstance.get<Overview>('transactions/overview');
};
